/*
AccountCode: ""
CallerIDName: "033817987946"
CallerIDNum: "033817987946"
Channel: "SIP/ext-sip-account-00000004"
ChannelState: "6"
ChannelStateDesc: "Up"
ConnectedLineName: "<unknown>"
ConnectedLineNum: "<unknown>"
Context: "von-voip-provider"
Event: "VarSet"
Exten: "777006100507"
Language: "en"
Linkedid: "1542376182.8"
Priority: "5"
Privilege: "dialplan,all"
Uniqueid: "1542376182.8"
Value: "00#002123456789123456777"
Variable: "NEATTALK"
context: "transfer-to"
exten: "777006100507"
priority: 1
*/

export interface AlertData {
  dateTime: number;
  AccountCode: string;
  CallerIDName: string;
  CallerIDNum: string;
  Channel: string;
  ChannelState: string;
  ChannelStateDesc: string;
  ConnectedLineName: string;
  ConnectedLineNum: string;
  Context: string;
  Event: string;
  Exten: string;
  Language: string;
  Linkedid: string;
  Priority: string;
  Privilege: string;
  Uniqueid: string;
  Value: string;
  Variable: string;
  context: string;
  exten: string;
  priority: number;
  editorPerson: string;
  code: string;
  desc: string;
  transmitterId: string;
  patientAlertGroups: Array<string|any>;
  isOpen: boolean;
  inProgress: boolean;
  progressStart: number|any;
  progressEnd: number|any;
  quit: any;
  notrufCallNumber?: string;
  location?: string;
  _rev?: any;
  _id?: any;
  firstname? : string;
  lastname? : string;
}

export class AlertData implements AlertData {
  dateTime: number = new Date().getTime();
  AccountCode = '';
  CallerIDName = '';
  CallerIDNum = '';
  Channel = '';
  ChannelState = '';
  ChannelStateDesc = '';
  ConnectedLineName = '';
  ConnectedLineNum = '';
  Context = '';
  Event = '';
  Exten = '';
  Language = '';
  Linkedid = '';
  Priority = '';
  Privilege = '';
  Uniqueid = '';
  Value = '';
  Variable = '';
  context = '';
  exten = '';
  priority = 0;
  editorPerson = '';
  code = '';
  desc = '';
  transmitterId = '';
  patientAlertGroups = [];
  isOpen = false;
  inProgress = false;
  progressStart = null;
  progressEnd = null;
  quit = null;
  constructor(){}
}
